// user profile
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const USER_PROFILE_ERROR = 'USER_PROFILE_ERROR';

// Fees
export const GET_FEES = 'GET_FEES';
export const GETTING_FEES= 'GETTING_FEES';
export const CREATE_FEE= 'CREATE_FEE';
export const CREATING_FEE = 'CREATING_FEE';
export const UPDATE_FEE= 'UPDATE_FEE';
export const UPDATING_FEE = 'UPDATING_FEE';
export const FEES_ERROR = 'FEES_ERROR';

// Classes
export const GET_CLASSES = 'GET_CLASSES';
export const GETTING_CLASSES = 'GETTING_CLASSES';
export const UPDATE_CLASS = 'UPDATE_CLASS';
export const UPDATING_CLASS = 'UPDATING_CLASS';
export const CLASSES_ERROR = 'CLASSES_ERROR';

// class divisions
export const GET_CLASS_DIVISIONS = 'GET_CLASS_DIVISIONS';
export const GETTING_CLASS_DIVISIONS = 'GETTING_CLASS_DIVISIONS';
export const UPDATE_CLASS_DIVISION = 'UPDATE_CLASS_DIVISION';
export const UPDATING_CLASS_DIVISION = 'UPDATING_CLASS_DIVISION';
export const CREATE_CLASS_DIVISION = 'CREATE_CLASS_DIVISION';
export const CREATING_CLASS_DIVISION = 'CREATING_CLASS_DIVISION';


// Housing
export const GET_HOUSES = 'GET_HOUSES';
export const GETTING_HOUSES = 'GETTING_HOUSES';
export const UPDATE_HOUSE = 'UPDATE_HOUSE';
export const UPDATING_HOUSE = 'UPDATING_HOUSE';
export const CREATE_HOUSE = 'CREATE_HOUSE';
export const CREATING_HOUSE = 'CREATING_HOUSE';
export const GET_HOUSE_BLOCKS = 'GET_HOUSE_BLOCKS';
export const GETTING_HOUSE_BLOCKS = 'GETTING_HOUSE_BLOCKS';
export const UPDATE_HOUSE_BLOCK = 'UPDATE_HOUSE_BLOCK';
export const UPDATING_HOUSE_BLOCK = 'UPDATING_HOUSE_BLOCK';
export const CREATE_HOUSE_BLOCK = 'CREATE_HOUSE_BLOCK';
export const CREATING_HOUSE_BLOCK = 'CREATING_HOUSE_BLOCK';
export const HOUSING_ERROR = 'HOUSING_ERROR';

// Examinations
export const GET_EXAMINATIONS = 'GET_EXAMINATIONS';
export const GETTING_EXAMINATIONS = 'GETTING_EXAMINATIONS';
export const CREATE_EXAMINATION = 'CREATE_EXAMINATION';
export const CREATING_EXAMINATION = 'CREATING_EXAMINATION';
export const UPDATE_EXAMINATION = 'UPDATE_EXAMINATION';
export const UPDATING_EXAMINATION = 'UPDATING_EXAMINATION';
export const EXAMINATIONS_ERROR = 'EXAMINATIONS_ERROR';

// Examination centers
export const GET_EXAMINATION_CENTERS = 'GET_EXAMINATION_CENTERS';
export const GETTING_EXAMINATION_CENTERS= 'GETTING_EXAMINATION_CENTERS';
export const CREATE_EXAMINATION_CENTER= 'CREATE_EXAMINATION_CENTER';
export const CREATING_EXAMINATION_CENTER = 'CREATING_EXAMINATION_CENTER';
export const UPDATE_EXAMINATION_CENTER = 'UPDATE_EXAMINATION_CENTER';
export const UPDATING_EXAMINATION_CENTER= 'UPDATING_EXAMINATION_CENTER';
export const DELETE_EXAMINATION_CENTER = 'DELETE_EXAMINATION_CENTER';
export const DELETING_EXAMINATION_CENTER= 'DELETING_EXAMINATION_CENTER';
export const EXAMINATION_CENTERS_ERROR = 'EXAMINATION_CENTERS_ERROR';

// exam schedules
export const GET_EXAM_SCHEDULES = 'GET_EXAM_SCHEDULES';
export const GETTING_EXAM_SCHEDULES = 'GETTING_EXAM_SCHEDULES';
export const CREATE_EXAM_SCHEDULE = 'CREATE_EXAM_SCHEDULE';
export const CREATING_EXAM_SCHEDULE = 'CREATING_EXAM_SCHEDULE';
export const UPDATE_EXAM_SCHEDULE = 'UPDATE_EXAM_SCHEDULE';
export const UPDATING_EXAM_SCHEDULE = 'UPDATING_EXAM_SCHEDULE';
export const DELETE_EXAM_SCHEDULE = 'DELETE_EXAM_SCHEDULE';
export const DELETING_EXAM_SCHEDULE = 'DELETING_EXAM_SCHEDULE';
export const EXAM_SCHEDULES_ERROR = 'EXAM_SCHEDULES_ERROR';

// Academic sessions
export const GET_ACADEMIC_SESSIONS = 'GET_ACADEMIC_SESSIONS';
export const GETTING_ACADEMIC_SESSIONS= 'GETTING_ACADEMIC_SESSIONS';
export const CREATE_ACADEMIC_SESSION = 'CREATE_ACADEMIC_SESSION';
export const CREATING_ACADEMIC_SESSION = 'CREATING_ACADEMIC_SESSION';
export const UPDATE_ACADEMIC_SESSION= 'UPDATE_ACADEMIC_SESSION';
export const UPDATING_ACADEMIC_SESSION= 'UPDATING_ACADEMIC_SESSION';
export const ACADEMIC_SESSIONS_ERROR = 'ACADEMIC_SESSIONS_ERROR';

// Departments
export const GET_DEPARTMENTS = 'GET_DEPARTMENTS';
export const GETTING_DEPARTMENTS = 'GETTING_DEPARTMENTS';
export const CREATE_DEPARTMENT = 'CREATE_DEPARTMENT';
export const CREATING_DEPARTMENT = 'GETTING_DEPARTMENTS';
export const UPDATING_DEPARTMENT = 'UPDATING_DEPARTMENT';
export const UPDATED_DEPARTMENT = 'UPDATED_DEPARTMENT';
export const DELETING_DEPARTMENT = 'DELETING_DEPARTMENT';
export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT';
export const DEPARTMENTS_ERROR = 'DEPARTMENTS_ERROR';

// Documents
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const GETTING_DOCUMENTS = 'GETTING_DEPARTMENTS';
export const CREATE_DOCUMENT = 'CREATE_DEPARTMENT';
export const UPDATING_DOCUMENT = 'UPDATING_DOCUMENTS';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const CREATING_DOCUMENT = 'GETTING_DEPARTMENTS';
export const SIGN_DOCUMENT = 'SIGN_DOCUMENT';
export const SIGNING_DOCUMENT = 'SIGNING_DOCUMENT';
export const DOCUMENTS_ERROR = 'DEPARTMENTS_ERROR';

// Downloadables
export const GET_DOWNLOADABLES = 'GET_DOWNLOADABLES';
export const GETTING_DOWNLOADABLES = 'GETTING_DOWNLOADABLES';
export const CREATE_DOWNLOADABLE = 'CREATE_DOWNLOADABLE';
export const CREATING_DOWNLOADABLE = 'CREATING_DOWNLOADABLE';
export const UPDATE_DOWNLOADABLE = 'UPDATE_DOWNLOADABLE';
export const UPDATING_DOWNLOADABLE = 'UPDATING_DOWNLOADABLE';
export const DELETE_DOWNLOADABLE = 'DELETE_DOWNLOADABLE';
export const DELETING_DOWNLOADABLE = 'DELETING_DOWNLOADABLE';
export const DOWNLOADABLES_ERROR = 'DOWNLOADABLES_ERROR';

// Groups
export const GET_GROUPS = 'GET_GROUPS';
export const GETTING_GROUPS = 'GETTING_GROUPS';
export const CREATE_GROUP = 'CREATE_GROUP';
export const CREATING_GROUP = 'CREATING_GROUP';
export const GROUPS_ERROR = 'GROUPS_ERROR';

// Document requests
export const GET_DOCUMENT_REQUESTS = 'GET_DOCUMENT_REQUESTS';
export const GETTING_DOCUMENT_REQUESTS = 'GETTING_DOCUMENT_REQUESTS';
export const CREATE_DOCUMENT_REQUEST = 'CREATE_DOCUMENT_REQUEST';
export const CREATING_DOCUMENT_REQUEST = 'CREATING_DOCUMENT_REQUEST';
export const UPDATE_DOCUMENT_REQUEST = 'UPDATE_DOCUMENT_REQUEST';
export const UPDATING_DOCUMENT_REQUEST = 'UPDATING_DOCUMENT_REQUEST';
export const DOCUMENT_REQUESTS_ERROR = 'DOCUMENT_REQUESTS_ERROR';

// Admissions
export const CREATE_ADMISSION = 'CREATE_ADMISSION';
export const CREATING_ADMISSION = 'CREATING_ADMISSION';
export const UPDATE_ADMISSION= 'UPDATE_ADMISSION';
export const UPDATING_ADMISSION = 'UPDATING_ADMISSION';
export const GET_ADMISSIONS = 'GET_ADMISSIONS';
export const GETTING_ADMISSIONS = 'GETTING_ADMISSIONS';
export const ADMISSIONS_ERROR = 'ADMISSIONS_ERROR';

// Payments
export const GET_PAYMENTS = 'GET_PAYMENTS';
export const GETTING_PAYMENTS = 'GETTING_PAYMENTS';
export const APPLY_PAYMENT = 'APPLY_PAYMENT';
export const APPLYING_PAYMENT = 'APPLYING_PAYMENT';
export const PAYMENTS_ERROR = 'PAYMENTS_ERROR';

// Payments
export const GET_PARENTS = 'GET_PARENTS';
export const GETTING_PARENTS = 'GETTING_PARENTS';
export const PARENTS_ERROR = 'PARENTS_ERROR';

// Applications
export const GET_APPLICATIONS = 'GET_APPLICATIONS';
export const GETTING_APPLICATIONS = 'GETTING_APPLICATIONS';
export const CREATE_APPLICATION = 'CREATE_APPLICATION';
export const CREATING_APPLICATION = 'CREATING_APPLICATION';
export const UPDATING_APPLICATION = 'UPDATING_APPLICATION';
export const UPDATED_APPLICATION = 'UPDATED_APPLICATION';
export const APPLICATIONS_ERROR = 'APPLICATIONS_ERROR';

// Application responses
export const GET_APPLICATION_RESPONSES = 'GET_APPLICATION_RESPONSES';
export const GETTING_APPLICATION_RESPONSES = 'GETTING_APPLICATION_RESPONSES';
export const CREATE_APPLICATION_RESPONSE = 'CREATE_APPLICATION_RESPONSE';
export const CREATING_APPLICATION_RESPONSE = 'CREATING_APPLICATION_RESPONSE';
export const APPLICATION_RESPONSES_ERROR = 'APPLICATION_RESPONSES_ERROR';

// Students
export const GET_STUDENTS = 'GET_STUDENTS';
export const GETTING_STUDENTS = 'GETTING_STUDENTS';
export const UPDATING_STUDENT = 'UPDATING_STUDENT';
export const UPDATED_STUDENT = 'UPDATED_STUDENT';
export const STUDENTS_ERROR = 'STUDENTS_ERROR';

// Staff
export const GET_STAFF = 'GET_STAFF';
export const GETTING_STAFF = 'GETTING_STAFF';
export const ONBOARDING_STAFF = 'ONBOARDING_STAFF';
export const ONBOARD_STAFF = 'ONBOARD_STAFF';
export const UPDATING_STAFF = 'UPDATING_STAFF';
export const UPDATED_STAFF = 'UPDATED_STAFF';
export const STAFF_ERROR = 'STAFF_ERROR';

export const RESEND_INVITATION = 'RESEND_INVITATION';
export const RESENDING_INVITATION = 'RESENDING_INVITATION';
export const REVOKE_INVITATION = 'REVOKE_INVITATION';
export const REVOKING_INVITATION = 'REVOKING_INVITATION';

// Designations
export const GET_DESIGNATIONS = 'GET_DESIGNATIONS';
export const GETTING_DESIGNATIONS = 'GETTING_DESIGNATIONS';
export const CREATE_DESIGNATION = 'CREATE_DESIGNATION';
export const CREATING_DESIGNATION = 'CREATING_DESIGNATION';
export const UPDATE_DESIGNATION = 'UPDATE_DESIGNATION';
export const UPDATING_DESIGNATION = 'UPDATING_DESIGNATION';
export const DESIGNATIONS_ERROR = 'DESIGNATIONS_ERROR';

// Roles & Permissions
export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GETTING_PERMISSIONS = 'GETTING_PERMISSIONS';
export const GET_ROLES = 'GET_ROLES';
export const GETTING_ROLES = 'GETTING_ROLES';
export const CREATE_ROLE = 'CREATE_ROLE';
export const CREATING_ROLE = 'CREATING_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const UPDATING_ROLE = 'UPDATING_ROLE';
export const ROLES_PERMISSIONS_ERROR = 'ROLES_PERMISSIONS_ERROR';

// Invoices
export const GET_INVOICES = 'GET_INVOICES';
export const GETTING_INVOICES = 'GETTING_INVOICES';
export const CREATE_INVOICE = 'CREATE_INVOICE';
export const CREATING_INVOICE = 'CREATING_INVOICE';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const UPDATING_INVOICE = 'UPDATING_INVOICE';
export const INVOICES_ERROR = 'INVOICES_ERROR';

// Invoice assignments
export const GET_INVOICE_ASSIGNMENTS = 'GET_INVOICE_ASSIGNMENTS';
export const GETTING_INVOICE_ASSIGNMENTS = 'GETTING_INVOICE_ASSIGNMENTS';
export const CREATING_INVOICE_ASSIGNMENT = 'CREATING_INVOICE_ASSIGNMENT';
export const CREATE_INVOICE_ASSIGNMENT = 'CREATE_INVOICE_ASSIGNMENT';

// Accounts
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GETTING_ACCOUNTS = 'GETTING_ACCOUNTS';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const CREATING_ACCOUNT = 'CREATING_ACCOUNT';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const DELETING_ACCOUNT = 'DELETING_ACCOUNT';
export const ACCOUNTS_ERROR = 'ACCOUNTS_ERROR';

// sundry accounts
export const GET_SUNDRY_ACCOUNTS = 'GET_SUNDRY_ACCOUNTS';
export const GETTING_SUNDRY_ACCOUNTS = 'GETTING_SUNDRY_ACCOUNTS';
export const GETTING_SUNDRY_TRANSACTIONS = 'GETTING_SUNDRY_TRANSACTIONS'
export const GET_SUNDRY_TRANSACTIONS = 'GET_SUNDRY_TRANSACTIONS'
export const CREATING_SUNDRY_TRANSACTION = 'CREATING_SUNDRY_TRANSACTION'
export const CREATE_SUNDRY_TRANSACTION = 'CREATE_SUNDRY_TRANSACTION'
export const SUNDRIES_ERROR = 'SUNDRIES_ERROR';

// Sundry items
export const GET_SUNDRY_ITEMS = 'GET_SUNDRY_ITEMS';
export const GETTING_SUNDRY_ITEMS = 'GETTING_SUNDRY_ITEMS';
export const CREATE_SUNDRY_ITEM = 'CREATE_SUNDRY_ITEM';
export const CREATING_SUNDRY_ITEM = 'CREATING_SUNDRY_ITEMS';
export const DELETE_SUNDRY_ITEM = 'DELETE_SUNDRY_ITEM';
export const DELETING_SUNDRY_ITEM = 'DELETING_SUNDRY_ITEM';
export const UPDATING_SUNDRY_ITEM = 'UPDATING_SUNDRY_ITEM';
export const UPDATE_SUNDRY_ITEM = 'UPDATE_SUNDRY_ITEM';

// Exeats
export const GET_EXEATS = 'GET_EXEATS';
export const GETTING_EXEATS = 'GETTING_EXEATS';
export const CREATE_EXEAT = 'CREATE_EXEAT';
export const CREATING_EXEAT = 'CREATING_EXEAT';
export const UPDATE_EXEAT = 'UPDATE_EXEAT';
export const UPDATING_EXEAT = 'UPDATING_EXEAT';
export const DELETE_EXEAT = 'DELETE_EXEAT';
export const DELETING_EXEAT = 'DELETING_EXEAT';
export const EXEATS_ERROR = 'EXEATS_ERROR';

// Accounts
export const GET_TERMS = 'GET_TERMS';
export const GETTING_TERMS = 'GETTING_TERMS';
export const CREATE_TERM = 'CREATE_TERM';
export const CREATING_TERM = 'CREATING_TERM';
export const UPDATE_TERM = 'UPDATE_TERM';
export const UPDATING_TERM = 'UPDATING_TERM';
export const TERMS_ERROR = 'TERMS_ERROR';

// Subjects
export const GET_SUBJECTS = 'GET_SUBJECTS';
export const GETTING_SUBJECTS = 'GETTING_SUBJECTS';
export const CREATE_SUBJECT = 'CREATE_SUBJECT';
export const CREATING_SUBJECT = 'CREATING_SUBJECT';
export const UPDATE_SUBJECT = 'UPDATE_SUBJECT';
export const UPDATING_SUBJECT = 'UPDATING_SUBJECT';
export const DELETING_SUBJECT = 'DELETING_SUBJECT';
export const DELETE_SUBJECT = 'DELETE_SUBJECT';
export const SUBJECTS_ERROR = 'SUBJECTS_ERROR';

// Assessments
export const GET_ASSESSMENTS = 'GET_ASSESSMENTS';
export const GETTING_ASSESSMENTS = 'GETTING_ASSESSMENTS';
export const CREATE_ASSESSMENT = 'CREATE_ASSESSMENT';
export const CREATING_ASSESSMENT = 'CREATING_ASSESSMENT';
export const UPDATE_ASSESSMENT = 'UPDATE_ASSESSMENT';
export const UPDATING_ASSESSMENT = 'UPDATING_ASSESSMENT';
export const GET_ASSESSMENT_RECORDS = 'GET_ASSESSMENT_RECORDS';
export const GETTING_ASSESSMENT_RECORDS = 'GETTING_ASSESSMENT_RECORDS';
export const CREATE_ASSESSMENT_RECORD = 'CREATE_ASSESSMENT_RECORD';
export const CREATING_ASSESSMENT_RECORD = 'CREATING_ASSESSMENT_RECORD';
export const UPDATE_ASSESSMENT_RECORD = 'UPDATE_ASSESSMENT_RECORD';
export const UPDATING_ASSESSMENT_RECORD = 'UPDATING_ASSESSMENT_RECORD';
export const DELETE_ASSESSMENT_RECORD = 'DELETE_ASSESSMENT_RECORD';
export const DELETING_ASSESSMENT_RECORD = 'DELETING_ASSESSMENT_RECORD';
export const ASSESSMENTS_ERROR = 'ASSESSMENTS_ERROR';

// Student feedback
export const GET_STUDENT_FEEDBACK = 'GET_STUDENT_FEEDBACK';
export const GETTING_STUDENT_FEEDBACK = 'GETTING_STUDENT_FEEDBACK';
export const CREATE_STUDENT_FEEDBACK = 'CREATE_STUDENT_FEEDBACK';
export const CREATING_STUDENT_FEEDBACK = 'CREATING_STUDENT_FEEDBACK';
export const UPDATE_STUDENT_FEEDBACK = 'UPDATE_STUDENT_FEEDBACK';
export const UPDATING_STUDENT_FEEDBACK = 'UPDATING_STUDENT_FEEDBACK';
export const DELETE_STUDENT_FEEDBACK = 'DELETE_STUDENT_FEEDBACK';
export const DELETING_STUDENT_FEEDBACK = 'DELETING_STUDENT_FEEDBACK';
export const STUDENT_FEEDBACK_ERROR = 'STUDENT_FEEDBACK_ERROR';

// Inventory
export const GET_INVENTORY_ITEMS = 'GET_INVENTORY_ITEMS';
export const GETTING_INVENTORY_ITEMS = 'GETTING_INVENTORY_ITEMS';
export const CREATE_INVENTORY_ITEM_CATEGORY = 'CREATE_INVENTORY_ITEM_CATEGORY';
export const CREATING_INVENTORY_ITEM_CATEGORY = 'CREATING_INVENTORY_ITEM_CATEGORY';
export const CREATE_INVENTORY_ITEM_VARIANT = 'CREATE_INVENTORY_ITEM_VARIANT';
export const CREATING_INVENTORY_ITEM_VARIANT = 'CREATING_INVENTORY_ITEM_VARIANT';
export const DELETING_INVENTORY_ITEM_CATEGORY = 'DELETING_INVENTORY_ITEM_CATEGORY';
export const DELETE_INVENTORY_ITEM_CATEGORY = 'DELETE_INVENTORY_ITEM_CATEGORY';
export const GET_INVENTORY_ITEM_VARIANTS = 'GET_INVENTORY_ITEM_VARIANT';
export const GETTING_INVENTORY_ITEM_VARIANTS = 'GETTING_INVENTORY_ITEM_VARIANT';
export const UPDATE_INVENTORY_ITEM_VARIANT = 'UPDATE_INVENTORY_ITEM_VARIANT';
export const UPDATING_INVENTORY_ITEM_VARIANT = 'UPDATING_INVENTORY_ITEM_VARIANT';
export const UPDATE_INVENTORY_ITEM_CATEGORY = 'UPDATE_INVENTORY_ITEM_CATEGORY';
export const UPDATING_INVENTORY_ITEM_CATEGORY = 'UPDATING_INVENTORY_ITEM_CATEGORY';
export const GET_INVENTORY_ITEM_CATEGORIES = 'GET_INVENTORY_ITEM_CATEGORIES';
export const GETTING_INVENTORY_ITEM_CATEGORIES = 'GETTING_INVENTORY_ITEM_CATEGORIES';
export const CREATE_INVENTORY_ITEM = 'CREATE_INVENTORY_ITEM';
export const CREATING_INVENTORY_ITEM = 'CREATING_INVENTORY_ITEM';
export const UPDATE_INVENTORY_ITEM = 'UPDATE_INVENTORY_ITEM';
export const UPDATING_INVENTORY_ITEM = 'UPDATING_INVENTORY_ITEM';
export const CREATE_INVENTORY_ITEM_ASSIGNMENT = 'CREATE_INVENTORY_ITEM_ASSIGNMENT';
export const CREATING_INVENTORY_ITEM_ASSIGNMENT = 'CREATING_INVENTORY_ITEM_ASSIGNMENT';
export const UPDATE_INVENTORY_ITEM_ASSIGNMENT = 'UPDATE_INVENTORY_ITEM_ASSIGNMENT';
export const UPDATING_INVENTORY_ITEM_ASSIGNMENT = 'UPDATING_INVENTORY_ITEM_ASSIGNMENT';
export const GET_INVENTORY_ITEM_ASSIGNMENT = 'GET_INVENTORY_ITEM_ASSIGNMENT';
export const GETTING_INVENTORY_ITEM_ASSIGNMENT = 'GETTING_INVENTORY_ITEM_ASSIGNMENT';
export const CREATE_INVENTORY_LOCATION = 'CREATE_INVENTORY_LOCATION';
export const CREATING_INVENTORY_LOCATION = 'CREATING_INVENTORY_LOCATION';
export const GETTING_INVENTORY_LOCATIONS = 'GETTING_INVENTORY_LOCATIONS';
export const GET_INVENTORY_LOCATIONS = 'GET_INVENTORY_LOCATIONS';
export const UPDATING_INVENTORY_LOCATION = 'UPDATING_INVENTORY_LOCATION';
export const UPDATE_INVENTORY_LOCATION = 'UPDATE_INVENTORY_LOCATION';
export const DELETING_INVENTORY_LOCATION = 'DELETING_INVENTORY_LOCATION';
export const DELETE_INVENTORY_LOCATION = 'DELETE_INVENTORY_LOCATION';
export const INVENTORY_ERROR = 'INVENTORY_ERROR';

// Disciplinary records
export const GET_DISCIPLINARY_RECORDS = 'GET_DISCIPLINARY_RECORDS';
export const GETTING_DISCIPLINARY_RECORDS = 'GETTING_DISCIPLINARY_RECORDS';
export const CREATE_DISCIPLINARY_RECORD = 'CREATE_DISCIPLINARY_RECORD';
export const CREATING_DISCIPLINARY_RECORD = 'CREATING_DISCIPLINARY_RECORD';
export const UPDATE_DISCIPLINARY_RECORD = 'UPDATE_DISCIPLINARY_RECORD';
export const UPDATING_DISCIPLINARY_RECORD = 'UPDATING_DISCIPLINARY_RECORD';
export const DELETE_DISCIPLINARY_RECORD = 'DELETE_DISCIPLINARY_RECORD';
export const DELETING_DISCIPLINARY_RECORD = 'DELETING_DISCIPLINARY_RECORD';
export const DISCIPLINARY_RECORDS_ERROR = 'DISCIPLINARY_RECORDS_ERROR';

// traits
export const GET_TRAITS = 'GET_TRAITS';
export const GETTING_TRAITS = 'GETTING_TRAITS';
export const CREATE_TRAIT = 'CREATE_TRAIT';
export const CREATING_TRAIT = 'CREATING_TRAIT';
export const UPDATE_TRAIT = 'UPDATE_TRAIT';
export const UPDATING_TRAIT = 'UPDATING_TRAIT';
export const DELETE_TRAIT = 'DELETE_TRAIT';
export const DELETING_TRAIT = 'DELETING_TRAIT';
export const TRAITS_ERROR = 'TRAITS_ERROR';

// Results
export const GET_RESULTS = 'GET_RESULTS';
export const GETTING_RESULTS = 'GETTING_RESULTS';
export const RESULTS_ERROR = 'RESULTS_ERROR';

// Student traits
export const GET_STUDENT_TRAITS = 'GET_STUDENT_TRAITS';
export const GETTING_STUDENT_TRAITS = 'GETTING_STUDENT_TRAITS';
export const UPDATING_STUDENT_TRAITS = 'UPDATING_STUDENT_TRAITS';
export const UPDATE_STUDENT_TRAITS = 'UPDATE_STUDENT_TRAITS';

// Sickbay records
export const GET_SICKBAY_RECORDS = 'GET_SICKBAY_RECORDS';
export const GETTING_SICKBAY_RECORDS = 'GETTING_SICKBAY_RECORDS';
export const GET_SICKBAY_RECORD = 'GET_SICKBAY_RECORD';
export const GETTING_SICKBAY_RECORD = 'GETTING_SICKBAY_RECORD';
export const CREATE_SICKBAY_RECORD = 'CREATE_SICKBAY_RECORD';
export const CREATING_SICKBAY_RECORD = 'CREATING_SICKBAY_RECORD';
export const UPDATE_SICKBAY_RECORD = 'UPDATE_SICKBAY_RECORD';
export const UPDATING_SICKBAY_RECORD = 'UPDATING_SICKBAY_RECORD';
export const GET_SICKBAY_STATS = 'GET_SICKBAY_STATS';
export const GETTING_SICKBAY_STATS = 'GETTING_SICKBAY_STATS';
export const SICKBAY_ERROR = 'SICKBAY_ERROR';

// Scholarships
export const GET_SCHOLARSHIPS = 'GET_SCHOLARSHIPS';
export const GETTING_SCHOLARSHIPS = 'GETTING_SCHOLARSHIPS';
export const CREATE_SCHOLARSHIP = 'CREATE_SCHOLARSHIP';
export const CREATING_SCHOLARSHIP = 'CREATING_SCHOLARSHIP';
export const UPDATE_SCHOLARSHIP = 'UPDATE_SCHOLARSHIP';
export const UPDATING_SCHOLARSHIP = 'UPDATING_SCHOLARSHIP';
export const DELETE_SCHOLARSHIP = 'DELETE_SCHOLARSHIP';
export const DELETING_SCHOLARSHIP = 'DELETING_SCHOLARSHIP';
export const GET_SCHOLARSHIP_ASSIGNMENTS = 'GET_SCHOLARSHIP_ASSIGNMENTS';
export const GETTING_SCHOLARSHIP_ASSIGNMENTS = 'GETTING_SCHOLARSHIP_ASSIGNMENTS';
export const CREATE_SCHOLARSHIP_ASSIGNMENT = 'CREATE_SCHOLARSHIP_ASSIGNMENT';
export const CREATING_SCHOLARSHIP_ASSIGNMENT = 'CREATING_SCHOLARSHIP_ASSIGNMENT';
export const UPDATE_SCHOLARSHIP_ASSIGNMENT = 'UPDATE_SCHOLARSHIP_ASSIGNMENT';
export const UPDATING_SCHOLARSHIP_ASSIGNMENT = 'UPDATING_SCHOLARSHIP_ASSIGNMENT';
export const DELETE_SCHOLARSHIP_ASSIGNMENT = 'DELETE_SCHOLARSHIP_ASSIGNMENT';
export const DELETING_SCHOLARSHIP_ASSIGNMENT = 'DELETING_SCHOLARSHIP_ASSIGNMENT';
export const SCHOLARSHIPS_ERROR = 'SCHOLARSHIPS_ERROR';

// Audit logs
export const GET_AUDIT_LOGS = 'GET_AUDIT_LOGS';
export const GETTING_AUDIT_LOGS = 'GETTING_AUDIT_LOGS';
export const AUDIT_LOGS_ERROR = 'AUDIT_LOGS_ERROR';

// Dashboard
export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const GETTING_DASHBOARD_DATA = 'GETTING_DASHBOARD_DATA';
export const DASHBOARD_ERROR = 'DASHBOARD_ERROR';

// Administrative Dashboard
export const GET_ADMIN_DASHBOARD_DATA = 'GET_ADMIN_DASHBOARD_DATA';
export const GETTING_ADMIN_DASHBOARD_DATA = 'GETTING_ADMIN_DASHBOARD_DATA';
export const ADMIN_DASHBOARD_ERROR = 'ADMIN_DASHBOARD_ERROR';

// Accounting Dashboard
export const GET_REVENUE_DATA = 'GET_REVENUE_DATA';
export const GETTING_REVENUE_DATA = 'GETTING_REVENUE_DATA';
export const REVENUE_DATA_ERROR = 'REVENUE_DATA_ERROR';
export const GET_FINANCE_DATA = 'GET_FINANCE_DATA';
export const GETTING_FINANCE_DATA = 'GETTING_FINANCE_DATA';
export const FINANCE_DATA_ERROR = 'FINANCE_DATA_ERROR';

// Academic Dashboard
export const GET_ACADEMIC_DASHBOARD = 'GET_ACADEMIC_DASHBOARD';
export const GETTING_ACADEMIC_DASHBOARD = 'GETTING_ACADEMIC_DASHBOARD';
export const ACADEMIC_DASHBOARD_ERROR = 'ACADEMIC_DASHBOARD_ERROR';

// Inventory Dashboard
export const GET_INVENTORY_DASHBOARD = 'GET_INVENTORY_DASHBOARD';
export const GETTING_INVENTORY_DASHBOARD = 'GETTING_INVENTORY_DASHBOARD';
export const INVENTORY_DASHBOARD_ERROR = 'INVENTORY_DASHBOARD_ERROR';

// Errors
export const ERROR = 'ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'

// Success
export const SET_SUCCESS = 'SET_SUCCESS'
export const CLEAR_SUCCESS = 'CLEAR_SUCCESS'